export default __webpack_public_path__ + "static/media/hcp-legend-icon-new.b9fd8720.svg";